<div class="boondocking-poi-card">
  <div class="boondocking-poi-outer">
    <div>
      <div class="boondocking-poi-info-outer">
        <div class="trip-planner-image" [ngStyle]="{ 'background-image': 'url(' + photoUrl + ')' }"></div>
        <div class="boondocking-poi-info-inner">
          <div class="poi-boondocking-name-inner">
            <div class="site-name">{{ activity?.getName() }}</div>
            <div class="location-copy" *ngIf="activity?.address && activity?.address?.city && activity?.address?.state">
              {{ activity.address?.city }}, {{ activity.address?.state }}
            </div>
            <div
              class="location-copy"
              *ngIf="
                (!activity?.address || !activity?.address?.city || !activity?.address?.state) && activity?.coordinates
              "
            >
              {{ activity.coordinates?.lat }}, {{ activity.coordinates?.lon }}
            </div>
          </div>
          <div class="poi-outer">
            <div *ngIf="activity?.hasActivity()" class="svg-icon">
              <curbnturf-category-svg icon="activity"> </curbnturf-category-svg>
            </div>
            <div *ngIf="activity?.categoryDump" class="svg-icon">
              <curbnturf-category-svg icon="dump"> </curbnturf-category-svg>
            </div>
            <div *ngIf="activity?.categoryRestArea" class="svg-icon">
              <curbnturf-category-svg icon="restArea"> </curbnturf-category-svg>
            </div>
            <div *ngIf="activity?.categoryWifi" class="svg-icon">
              <curbnturf-category-svg icon="wifi"> </curbnturf-category-svg>
            </div>
            <div *ngIf="activity?.categoryPotableWater" class="svg-icon">
              <curbnturf-category-svg icon="potableWater"> </curbnturf-category-svg>
            </div>
            <div *ngIf="activity?.categoryPropane" class="svg-icon">
              <curbnturf-category-svg icon="propane"> </curbnturf-category-svg>
            </div>
          </div>
        </div>
      </div>
      <div class="poi-add-fav-outer">
        <div class="favorite-outer" (click)="onFavorite($event)">
          <ion-icon [name]="favorite ? 'heart' : 'heart-outline'" color="orange"></ion-icon>
        </div>
        <div class="cnt-button trip" (click)="onAddToTrip($event)">
          <div class="cnt-button-icon">
            <div class="html-embed w-embed">
              <curbnturf-site-svgs type="rvtrip"></curbnturf-site-svgs>
            </div>
          </div>
          <div class="cnt-button-copy">Add To Trip</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="listing-card" *ngIf="false">
  <div class="listing-image-wrapper" [ngStyle]="{ 'background-image': 'url(' + photoUrl + ')' }">
    <curbnturf-save-site [poi]="activity" [icon]="true" size="small"> </curbnturf-save-site>
  </div>
  <div *ngIf="true" class="listing-info-wrapper">
    <div class="listing-title-wrapper">
      <h3 class="listing-name" [innerHTML]="activity?.getName()"></h3>
    </div>
    <div *ngIf="activity?.address?.city && activity?.address?.state" class="card-rift-soft">
      {{ activity?.address?.city }}, {{ activity?.address?.state }}
    </div>
    <div *ngIf="!activity?.address?.city || !activity?.address?.state" class="card-rift-soft">
      ({{ activity?.coordinates?.lat }}, {{ activity?.coordinates?.lon }})
    </div>
    <div class="poi-outer">
      <div *ngIf="activity?.hasActivity()" class="svg-icon">
        <curbnturf-category-svg icon="activity"> </curbnturf-category-svg>
      </div>
      <div *ngIf="activity?.categoryDump" class="svg-icon">
        <curbnturf-category-svg icon="dump"> </curbnturf-category-svg>
      </div>
      <div *ngIf="activity?.categoryRestArea" class="svg-icon">
        <curbnturf-category-svg icon="restArea"> </curbnturf-category-svg>
      </div>
      <div *ngIf="activity?.categoryWifi" class="svg-icon">
        <curbnturf-category-svg icon="wifi"> </curbnturf-category-svg>
      </div>
      <div *ngIf="activity?.categoryPotableWater" class="svg-icon">
        <curbnturf-category-svg icon="potableWater"> </curbnturf-category-svg>
      </div>
      <div *ngIf="activity?.categoryPropane" class="svg-icon">
        <curbnturf-category-svg icon="propane"> </curbnturf-category-svg>
      </div>
    </div>
  </div>
</div>
